import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import { FormInputWithLabel } from '../../../_core/form/input/form-labelled-input.component';
import { FormButton } from '../../../_core/form/button/form-button.component';
import { IRIFormProps } from '../../../_core/form/form.types';
import { getUrlValidationError } from '../../../../lib/url-validation';

export interface IUpdateRequestTypeFormValues {
  isGlobal: boolean;
  type: string;
  postSubmissionRedirectUrl?: string;
}

interface IUpdateRequestTypeFormProps extends IRIFormProps<IUpdateRequestTypeFormValues> {
  isGlobal: boolean;
  type: string;
  postSubmissionRedirectUrl?: string;
}

export const UpdateRequestTypeForm = ({ isGlobal, type, postSubmissionRedirectUrl, onSubmit }: IUpdateRequestTypeFormProps) => {
  const validateForm = (values: IUpdateRequestTypeFormValues) => {
    const errors: FormikErrors<IUpdateRequestTypeFormValues> = {};

    if (!values.type.trim()) {
      errors.type = 'Required';
    }

    if (values.postSubmissionRedirectUrl) {
      const urlError = getUrlValidationError(values.postSubmissionRedirectUrl);
      if (urlError) {
        errors.postSubmissionRedirectUrl = urlError;
      }
    }

    return errors;
  };

  return (
    <Formik
      initialValues={{
        isGlobal,
        type,
        postSubmissionRedirectUrl: postSubmissionRedirectUrl || ''
      } as IUpdateRequestTypeFormValues}
      onSubmit={(values) =>
        onSubmit({
          ...values,
          type: values.type.trim(),
          postSubmissionRedirectUrl: values.postSubmissionRedirectUrl?.trim() || ''
        })
      }
      validate={validateForm}
    >
      {(props: FormikProps<IUpdateRequestTypeFormValues>) => (
        <Form action="#" method="POST" className="sm:max-w-xl mx-auto space-y-4 mt-10">
          <FormInputWithLabel name="type" label="Type" placeholder="Edit request type" />

          <div className="border-t pt-4 mt-4">
            <h3 className="text-lg font-medium mb-4">Post-Submission Settings</h3>

            <FormInputWithLabel
              name="postSubmissionRedirectUrl"
              label="Post-Submission Redirect URL (Optional)"
              placeholder="https://example.com/thank-you"
            />

            <div className="text-sm text-gray-600 mt-2">
              <p>This setting applies only to this request type. Leave blank to use company defaults.</p>
            </div>
          </div>

          <FormButton loading={props.isSubmitting} text="Update" />
        </Form>
      )}
    </Formik>
  );
};
